<div class="edit-menu-wrap">
  <button class="pxl-menu-btn" (click)="toggle()" [disabled]="isSpectator" [class.disabled]="isSpectator" [title]="isSpectator ? 'Viewer mode: Edit menu is disabled' : 'Edit'">
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
    Edit
  </button>

  <div class="edit-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <button class="menu-item" [disabled]="!(canUndo$ | async)" (click)="undo()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>
      Undo <kbd>Ctrl+Z</kbd>
    </button>
    <button class="menu-item" [disabled]="!(canRedo$ | async)" (click)="redo()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 14 20 9 15 4"/><path d="M4 20v-7a4 4 0 0 1 4-4h12"/></svg>
      Redo <kbd>Ctrl+Y</kbd>
    </button>

    <div class="menu-separator"></div>

    <!-- Fx flyout -->
    <div class="menu-item-flyout" (mouseenter)="openFx()" (mouseleave)="closeFx()">
      <button class="menu-item menu-item--flyout-trigger">
        <span class="menu-item-left">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          Fx
        </span>
        <svg class="flyout-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
      <div class="fx-submenu" *ngIf="fxOpen">
        <button class="menu-item" (click)="openTweenModal()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Keyframe Tween
        </button>
      </div>
    </div>
  </div>

  <div class="edit-backdrop" *ngIf="isOpen" (click)="close()"></div>
</div>

<!-- Keyframe Tween Modal -->
<div class="tween-modal-backdrop" *ngIf="showTweenModal">
  <div class="tween-modal" (click)="$event.stopPropagation()">
    <div class="tween-modal-header">
      <span>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        Keyframe Tween
      </span>
      <button (click)="closeTweenModal()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="tween-modal-body">
      <div class="tween-hint">Generate interpolated frames between two keyframes</div>
      <div class="tween-row">
        <div class="tween-field">
          <label class="tween-label">FROM</label>
          <select class="pxl-input" [(ngModel)]="tweenFromId">
            <option *ngFor="let f of (allFrames$ | async); let i = index" [value]="f.id">F{{ i+1 }}</option>
          </select>
        </div>
        <div class="tween-field">
          <label class="tween-label">TO</label>
          <select class="pxl-input" [(ngModel)]="tweenToId">
            <option *ngFor="let f of (allFrames$ | async); let i = index" [value]="f.id">F{{ i+1 }}</option>
          </select>
        </div>
      </div>
      <div class="tween-field" style="margin-top:8px">
        <label class="tween-label">STEPS</label>
        <input type="number" class="pxl-input" [(ngModel)]="tweenSteps" min="1" max="12" style="width:70px">
      </div>
      <button class="pxl-btn pxl-btn-secondary pxl-btn-sm" style="margin-top:10px;width:100%"
        (click)="tweenFrames()" [disabled]="!tweenFromId || !tweenToId || tweenFromId === tweenToId">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        Generate Tween
      </button>
    </div>
  </div>
</div>
